import './index.css';
import React, { useState, useEffect } from 'react';
import imgPerfil from "../../img/imgPerfil.webp"
import { jwtDecode } from 'jwt-decode';

import logo from '../../img/logo/LOGO INICIALES.png';
import apiClient from '../../acciones/apiClient';
import { useHistory } from 'react-router-dom';


export const NavBar = () => {
    const [isNavbarFixed, setIsNavbarFixed] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userRole, setUserRole] = useState('');

    //const [mayor18, setMayor18] = useState(false);

    const [mayor18, setMayor18] = useState(() => {
        const saved = localStorage.getItem('mayor18');
        return saved === 'true';  // convierte string a boolean
    });

    const [searchQuery, setSearchQuery] = useState('');
    const history = useHistory();

    const handleSearchSubmit = (e) => {
        e.preventDefault(); // Previene el comportamiento por defecto del formulario
        if (searchQuery.trim() !== '') {
            console.log(`Buscando: ${searchQuery}`); // Agrega un console.log para verificar
            history.push(`/Series?search=${searchQuery.trim()}`); // Redirige a la URL con el query
        } else {
            console.log("La búsqueda está vacía."); // Mensaje para depurar
        }
    };


    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const decodedToken = jwtDecode(token);
                setIsLoggedIn(true);

                // Asigna el rango del usuario
                if (decodedToken && decodedToken.rango) {
                    setUserRole(decodedToken.rango);
                }

                /// Obtener el estado inicial del campo mayor_18
                const fetchUserData = async () => {
                    try {
                        const response = await apiClient.get(
                            `/usuarios/perfil/${decodedToken.id}`
                        );
                        setMayor18(response.data.mayor_18 || false); // Establece el estado inicial
                    } catch (error) {
                        console.error("Error al obtener datos del usuario:", error);
                    }
                };
                fetchUserData();

            } catch (error) {
                console.error('Error al decodificar el token:', error);
                setIsLoggedIn(false);
            }
        }

        const handleScroll = () => {
            const nav = document.querySelector('.nav');
            const imageContainer = document.querySelector('.image-container');
            const navHeight = nav?.offsetHeight || 0;
            const imageHeight = imageContainer?.offsetHeight || 0;
            const shouldFix = window.scrollY > imageHeight - navHeight;
        
            // Evita cambios si el valor no ha cambiado
            setIsNavbarFixed(prev => {
                if (prev !== shouldFix) return shouldFix;
                return prev;
            });
        };
        

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []); // Retiramos userRole de las dependencias para evitar loops innecesarios


    const handleLogout = () => {
        localStorage.removeItem('token');
        setIsLoggedIn(false);
        setUserRole('');
        window.location.href = '/iniciarSesion'; // Redirige a la página de inicio de sesión
    };

    const handleMayor18Change = async (e) => {
        const newValue = e.target.checked;
        console.log("El nuevo valor en +18 es: ",newValue);
        setMayor18(newValue); // Actualiza el estado local
        localStorage.setItem('mayor18', newValue); // ← Guarda en localStorage al cambiar
    
        try {
            const token = localStorage.getItem('token');
            const decodedToken = jwtDecode(token);
    
            // Actualizar el campo en la base de datos
            await apiClient.put(
                `/usuarios/perfil/${decodedToken.id}`,
                { mayor_18: newValue },
                { headers: { "Content-Type": "application/json" } }
            );
        } catch (error) {
            console.error("Error al actualizar el estado de mayor_18:", error);
        }
    };
    

    return (
        <div>
            <nav className={`nav ${isNavbarFixed ? 'fixed' : ''} navbar navbar-expand-lg bg-info nav`} >

                <div class="container-fluid">

                    <div className="menu-toggle">
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent"
                            aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                    </div>

                    <a class="navbar-brand" href="/">
                        <img src={logo} alt="Cartel de Manhwas" height="50" className="mx-auto" />
                    </a>

                    <div class="collapse navbar-collapse" id="navbarSupportedContent">

                        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                            <li class="nav-item">
                                <a class="nav-link active" aria-current="page" href="/">Inicio</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/Series">Lista de Series</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/FamiliaCartel">Familia de Cartel</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="https://discord.gg/W8vx84gCSG">Únete a la Familia</a>
                            </li>
                        </ul>

                        <button class="button">
                            <a href="/notificaciones">
                                <svg viewBox="0 0 448 512" class="bell"><path d="M224 0c-17.7 0-32 14.3-32 32V49.9C119.5 61.4 64 124.2 64 200v33.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416H424c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32zm0 96h8c57.4 0 104 46.6 104 104v33.4c0 47.9 13.9 94.6 39.7 134.6H72.3C98.1 328 112 281.3 112 233.4V200c0-57.4 46.6-104 104-104h8zm64 352H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"></path></svg>
                            </a>
                        </button>


                        <div className="mas18Navbar">
                            <h5>+18</h5>
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={mayor18} // Vincula el estado al checkbox
                                    onChange={handleMayor18Change}
                                />
                                <span className="slider"></span>
                            </label>
                        </div>

                        <form className="form" onSubmit={handleSearchSubmit}>
                            <button type="submit">
                                <svg width="17" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="search">
                                    <path d="M7.667 12.667A5.333 5.333 0 107.667 2a5.333 5.333 0 000 10.667zM14.334 14l-2.9-2.9" stroke="currentColor" strokeWidth="1.333" strokeLinecap="round" strokeLinejoin="round"></path>
                                </svg>
                            </button>
                            <input
                                className="input"
                                placeholder="Buscar..."
                                required
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <button className="reset" type="reset">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                            </button>
                        </form>


                        {/* Si el usuario está logueado, mostrar perfil; si no, mostrar "Iniciar Sesión" */}
                        {isLoggedIn ? (
                            <div className="perfil-containerNav">
                                <div className="perfilNav">
                                    <img src={imgPerfil} alt="Imagen de perfil" className="imagen-perfilNav" />
                                </div>
                                <div className="menu-desplegableNav">
                                    <ul>
                                        <li><a href="/PerfilUsuario">Perfil</a></li>
                                        {userRole === 'administrador' && (
                                            <li><a href="/Administrador">Administrador</a></li>
                                        )}
                                        <li><a href={`/Favoritos/${jwtDecode(localStorage.getItem('token')).id}`}>Favoritos</a></li>
                                        <li><a href="/configuracion">Configuración</a></li>
                                        <li><a onClick={handleLogout}>Desconectar</a></li>
                                    </ul>
                                </div>
                            </div>
                        ) : (
                            <div className='IniSesi'>
                                <a href="/iniciarSesion">Iniciar Sesión</a>
                            </div>
                        )}
                    </div>

                </div>
            </nav>
        </div>
    );
};
